export var calcZoom = function calcZoom(_ref) {
  var cropBoxScale = _ref.cropBoxScale,
    cropBoxSize = _ref.cropBoxSize,
    imageBgSize = _ref.imageBgSize,
    imageNaturalSize = _ref.imageNaturalSize;
  var min = 1;
  var max = 1;
  var maxZoomScale = 1;
  var isLtCropBox = imageNaturalSize.width <= cropBoxSize.width || imageNaturalSize.height <= cropBoxSize.height;
  if (isLtCropBox) {
    maxZoomScale = 2;
  }
  if (imageNaturalSize.width <= imageNaturalSize.height) {
    min = cropBoxSize.width * cropBoxScale / imageBgSize.width;
    var oppositeMin = cropBoxSize.height * cropBoxScale / imageBgSize.height;
    if (oppositeMin > min) {
      min = oppositeMin;
    }
    if (isLtCropBox) {
      max = cropBoxSize.width * cropBoxScale * maxZoomScale / (imageBgSize.width * cropBoxScale);
    } else {
      max = imageNaturalSize.width * maxZoomScale / imageBgSize.width * cropBoxScale;
    }
  } else {
    min = cropBoxSize.height * cropBoxScale / imageBgSize.height;
    var _oppositeMin = cropBoxSize.width * cropBoxScale / imageBgSize.width;
    if (_oppositeMin > min) {
      min = _oppositeMin;
    }
    if (isLtCropBox) {
      max = cropBoxSize.height * cropBoxScale * maxZoomScale / (imageBgSize.height * cropBoxScale);
    } else {
      max = imageNaturalSize.height * maxZoomScale / imageBgSize.height * cropBoxScale;
    }
  }
  min = Number(min.toFixed(3));
  max = Number(max.toFixed(3));
  return {
    value: min,
    min: min,
    max: max
  };
};